import styled from '@independent-software/typeui/styles/Theme'

const Container = styled('div')`
  display: flex;
  justify-content: stretch;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`

export { Container };